import {
    Component, Input, Output, EventEmitter,
    ViewChild, ViewChildren, ChangeDetectorRef
} from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams, HttpEventType, HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';

import { ToastrService } from 'ngx-toastr';

//import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

//import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//import { UserService } from '../../services/user.service';
//import { RegistrationDataService } from '../../services/registration.data.service';

//import { RegistrationValidationComponent } from '../../modals/sign_up_validation.modal/sign_up_validation.modal.component';

import { UserPostsDataService } from '../../services/posts.service';
import { SessionService } from '../../services/session.service';

import { PostFooterComponent } from '../../components/insertable/post-footer/post-footer.component';

import *  as Classes from '../../classes/models.classes'

@Component({
    selector: 'app-post-submit-modal',
    templateUrl: './post-submit-modal.component.html',
    styleUrls: ['./post-submit-modal.component.css']
})
export class PostSubmitModalComponent {
    @ViewChild('footerComponent') footerComponent!: PostFooterComponent;

    @Output() postEditedOrDeleted = new EventEmitter<string>(); // Emit the comment

    @Output() mediaUrlsChangeModal = new EventEmitter<any[]>();
    @Output() replyTypeChange = new EventEmitter<any>();
    @Output() postContent = new EventEmitter<string>(); 
    @Output() onSave = new EventEmitter<void>();      

    comment: string = 'refresh';

    UserPostsDataContent: Classes.ShortsPostSave;

    UserID: number;
    Username: string;
    UserImg: string;

    mediaUrlsModal: any[] = [];
    replyTypesModal = [
        { id: 1, text: 'Everyone', icon: 'path/to/everyone.svg' },
        { id: 2, text: 'Accounts You Follow', icon: 'path/to/accounts-follow.svg' },
        { id: 3, text: 'Verified Accounts', icon: 'path/to/verified-accounts.svg' },
        { id: 4, text: 'Only Accounts You Mention', icon: 'path/to/accounts-mention.svg' }
    ];

    selectedReplyType = this.replyTypesModal[0];  // default to Everyone

    hasPostText: boolean = false; // Tracks whether there is post text to enable post button


    constructor(
        private sessionService: SessionService,
        private userPostsDataService: UserPostsDataService,
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef,
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit(): void {
        this.sessionService.getUserID().subscribe(userID => {
            this.UserID = Number(userID);
        });

        this.sessionService.getUsername().subscribe(username => {
            this.Username = username;
        });

        this.sessionService.getUserImg().subscribe(userImg => {
            this.UserImg = userImg;
        });


        this.UserPostsDataContent = new Classes.ShortsPostSave();

        //console.log("Post MODAL this.mediaUrlsModal: ", this.mediaUrlsModal);  // Log the entire event to see what properties are available

        //console.log("Post Modal Initialized");
        if (this.footerComponent) {
            this.footerComponent.mediaUrlsChange.subscribe(media => {
                //console.log("Post Modal Manually Listening to mediaUrlsChange!");
                this.updatePostMediaUrlsModal(media);
            });
        }

    }

    ngAfterViewInit() {
        //console.log("Post Modal Ready to Receive Events");

        setTimeout(() => {
            if (this.footerComponent) {
                //console.log("Subscribing to Footer's mediaUrlsChange...");
                this.footerComponent.mediaUrlsChange.subscribe(media => {
                    //console.log("Post Modal Manually Listening to mediaUrlsChange!", media);
                    this.updatePostMediaUrlsModal(media);
                });
            } else {
            //    console.error("Footer Component not found in Post Modal!");
            }
        }, 100); // Wait for Angular to render dynamically added components
    }

    updatePostContent(postContent: string) {
        this.UserPostsDataContent.PostContent = postContent;
        if (postContent && postContent.length > 0) {
            this.hasPostText = true;
        }
    }

    //updatePostMediaUrlsModal(media: any[]) {
    //    //this.mediaUrlsModal = media;
    //    this.mediaUrlsModal = media.map(item => ({ ...item })); // Shallow copy to avoid reference sharing
    //    this.cdr.detectChanges();  // Force Angular to recognize the change

    //    console.log("Post MODAL this.mediaUrlsModal: ", this.mediaUrlsModal);  // Log the entire event to see what properties are available
    //}

    updatePostMediaUrlsModal(media: any[]) {
        this.mediaUrlsModal = media.map(item => ({ ...item })); // Shallow copy to avoid reference sharing


        //console.log("Post Modal updatePostMediaUrlsModal() Triggered!"); // Debugging

        //if (!media || media.length === 0) {
        //    console.warn("Post Modal received EMPTY mediaUrlsModal!");
        //    return;
        //}

        //this.mediaUrlsModal = media.map(item => {
        //    return {
        //        url: item.url,
        //        file: item.file ? item.file : null,  // Preserve the File object
        //        isVideo: item.isVideo,
        //        isTenor: item.isTenor,
        //        isPlaying: item.isPlaying,
        //        animatedUrl: item.animatedUrl,
        //        previewUrl: item.previewUrl,
        //        mimeType: item.mimeType,
        //        index: item.index
        //    };
        //});

        //console.log("Post Modal Received mediaUrlsModal:", this.mediaUrlsModal);
        //this.cdr.detectChanges(); // Force UI update
    }

    updateReplyTypeModal(type: any) {
        this.selectedReplyType = type;
    }

    removeMediaFromFooter(index: number): void {
        if (this.footerComponent) {
            this.footerComponent.removeMediaAtIndex(index);
        } else {
            console.error("FooterComponent not initialized yet.");
        }
    }


    onPostSaved(): void {
        this.postEditedOrDeleted.emit(this.comment); // Emit the comment to the parent component
        this.activeModal.close(); // Close the modal
    }

    onCancel(): void {
        this.activeModal.dismiss(); // Dismiss the modal without doing anything
    }

    handleSave(): void {
        this.mediaUrlsChangeModal.emit(this.mediaUrlsModal);
        this.replyTypeChange.emit(this.selectedReplyType);
        this.postContent.emit(this.UserPostsDataContent.PostContent);
        this.onSave.emit();
    }

    savePost(): void {

        this.UserPostsDataContent.UserID = this.UserID;
        this.UserPostsDataContent.PostType = 1;
        this.UserPostsDataContent.PublishDate = new Date() // Date is set at the time of submission
        this.UserPostsDataContent.ReplyType = this.selectedReplyType.id; // Save replyType selection

        const formData = new FormData();

        formData.append('postData', JSON.stringify(this.UserPostsDataContent)); // Serialize your object into a JSON string

        // Add each media file or URL
        this.mediaUrlsModal.forEach((mediaItem, index) => {
            if (!mediaItem.isTenor) {
                // Append local file
                formData.append(`file_${index}`, mediaItem.file!, mediaItem.file!.name);
                formData.append('mimeType', mediaItem.mimeType!);
            } else {
                // Append Tenor URL and Animated URL concatenated with a delimiter (e.g., `|`)
                const combinedUrl = `${mediaItem.url}|${mediaItem.animatedUrl}`;
                formData.append(`gifUrl_${index}`, combinedUrl);
            }
        });

        // Call service to save post
        this.userPostsDataService.savePost(formData, this.UserID).subscribe({
            next: (response) => {
                //console.log('Post saved successfully', response);
                this.toastr.success('Post saved successfully!');

                // Emit the event to refresh posts
                //this.postSaved.emit();

                // Reset post content and media URLs
                this.UserPostsDataContent.PostContent = '';
                this.mediaUrlsModal = [];

                // Just refresh the posts
                //this.getUserPostsDataNew(true);

                this.postEditedOrDeleted.emit(this.comment); // Emit the comment to the parent component
                this.activeModal.close(); // Close the modal
            },
            error: (error) => {
                //console.error('Error saving post', error);
                this.toastr.error('Error saving post!');
            }
        });
    }      



}

